// Imports from external sources
// React, i18next, Router, Mantine, Further Stuff
import {   
    Flex, 
} from '@mantine/core'

// Imports from vseth-canine-ui


// Imports from this projects
// Pages, Components, Features, Hooks
import { 
    DeleteItemButton 
} from '../../../components/buttons/delete/DeleteItemButton'

import { 
    CancelButton 
} from '../../../components/buttons/form/CancelButton'


interface DeleteItemBarProps {
    editItemId: number,
}


/**
 * This menu bar renders the save, save&close and cancel button.
 */
export const DeleteItemBar = (props: DeleteItemBarProps) => {   
    return (
        <Flex 
            direction={{ base: 'column', sm: 'row' }}
            gap={{ base: 'sm', sm: 'lg' }}
            justify={{ sm: 'flex-end' }}
        >
            <DeleteItemButton
                editItemId = {props.editItemId}
            />
            <CancelButton/>
        </Flex>   
    )
} 